module.exports = __webpack_public_path__ + "static/5-85034817b8470daa7ebf0fd3922ec065.png";